var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticClass:"hvh-chart",style:({ height: _vm.height }),attrs:{"visualization":_vm.visualization},on:{"wheel":function($event){return _vm.$emit('wheel', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }